// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__SsYYl","label":"SetPasswdForm_label__3FVCv"};